<template>
  <div class="detail-container">
    <el-row>
      <el-col :span="4">学号</el-col>
      <el-col :span="20">{{ detailInfo.studentNo }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">身份证号</el-col>
      <el-col :span="20">{{ detailInfo.idCard }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">姓名</el-col>
      <el-col :span="20">{{ detailInfo.studentName || detailInfo.name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">学院</el-col>
      <el-col :span="20">{{ detailInfo.collegeName }}</el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="4">系别</el-col>
      <el-col :span="20">{{ detailInfo.departmentName }}</el-col>
    </el-row> -->
    <el-row>
      <el-col :span="4">专业</el-col>
      <el-col :span="20">{{ detailInfo.majorName }}</el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="4">班级</el-col>
      <el-col :span="20">{{ detailInfo.className }}</el-col>
    </el-row> -->
      <el-row>
      <el-col :span="4">预计到校时间：</el-col>
      <el-col :span="20">{{ detailInfo.arriveSchoolTime }}</el-col>
    </el-row>
       <el-row>
      <el-col :span="4">预计交通方式:</el-col>
      <el-col :span="20">{{ detailInfo.trafficType }}</el-col>
    </el-row>
       <el-row>
      <el-col :span="4">车次信息:</el-col>
      <el-col :span="20">{{ detailInfo.trainInfo }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="24"> 健康码、行程码等材料: </el-col>
    </el-row>
    <el-row>
      <el-col :span="20" class="img-row">
        <div
          class="evidence-img-item img-item"
          v-for="(item, index) in detailInfo.pictureUrl"
          :key="index"
        >
          <el-image
            style="width: 100px; height: 100px"
            z-index="9999"
            :src="item"
            :preview-src-list="detailInfo.pictureUrl"
          >
          </el-image>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
    };
  },
  props: {
      detailInfo:{
          type:Object,
          default:{},
      },
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {

  },
};
</script>
